angular.module('todo')
    .controller('TodoChangeStatusController', function ($scope, $rootScope, $uibModalInstance, Todo, TodoService, data) {
        this.$onInit = () => {
            this.statuses = TodoService.statuses()
            this.item = data
            this.form = {
                id: data.id,
                status: data.status
            }
        }
        this.save = () => {
            return Todo.changeStatus({id: this.item.id}, this.form).$promise.then(() => {
                $uibModalInstance.close()
                $rootScope.$broadcast('todo.updated')
            })
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
